import { useRef, useState } from "react"
import { InputForm } from "../atoms/input"
import { StandardButton } from "../atoms/buttons"
import { VerticalLayout } from "../components/layout"

export const OrderOptions = ({data,updateContent}) => {
    const MAXOPTIONS = 6
    const [inputCount, setInputCount] = useState(data?.quiz_answers ? data.quiz_answers:[{ text: "", inputID: 1 }, { text: "", inputID: 2 }, { text: "", inputID: 3 }])
    const [quizQuestion, setQuizQuestion] = useState(data?.quiz_question || "");
    const counter = useRef(3)
    const addExtraOption = () => {
        counter.current++
        const copyInput = [...inputCount, { text: "", inputID: counter.current }]
        setInputCount(copyInput)
        updateContent({quiz_answer_content:copyInput})
    }

    const removeExtraOption = (index) => {
        const copyInput = [...inputCount]
        copyInput.splice(index, 1)
        setInputCount(copyInput)
        updateContent({quiz_answer_content:copyInput})
    }

    const orderValue = (value,index) => {
        const copyInput = [...inputCount]
        copyInput[index].text = value
        setInputCount(copyInput)
        console.log(copyInput)
        
        updateContent({quiz_answer_content:copyInput,           quiz_question: quizQuestion})
        
    }
    const changeQuestionTitle = (newTitle) => {
        setQuizQuestion(newTitle);
        updateContent({
          quiz_question: newTitle,
          quiz_answer_content: inputCount,
        });
      };
    

    return (
        <>  
        <InputForm title={"Quiz vraag:"} value={quizQuestion} placeholder={"Voeg hier uw vraag in"} typeInput={(newText) => changeQuestionTitle(newText)} />
        <div className="horizontal match-mol" >
          
            <VerticalLayout style={{ height : "auto" }}>
                {inputCount.map((option, index) => {
                    return (
                        <InputForm
                            typeInput={(text) => orderValue(text,index) }
                            action={() => removeExtraOption(index)}
                            rightIcon={(inputCount.length > 3)}
                            iconName={"trash"}
                            key={option.inputID}
                            value={option.text}
                            placeholder={`Vul hier optie ${index + 1} in`}
                      />
                    )
                })}
                {MAXOPTIONS > inputCount.length &&
                    <StandardButton
                    className={"no-margin-left"}
                        onClick={() => addExtraOption()}
                        title={"Voeg extra optie toe"}
                    />
                }

            </VerticalLayout>

        </div>
    </>)
}